import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { DotPattern } from '../ui/magic/DotPattern';

export const FinalCTA: React.FC = () => {
  return (
    <section id="contact" className="py-32 bg-white overflow-hidden border-t border-slate-200 relative">
      <DotPattern className="fill-slate-300/50 [mask-image:radial-gradient(560px_circle_at_72%_50%,white,transparent)]" />
      {/* Full height vertical lines at container edges */}
      <div className="absolute inset-0 max-w-7xl mx-auto pointer-events-none">
        <div className="absolute left-0 top-0 bottom-0 w-px bg-slate-200"></div>
        <div className="absolute right-0 top-0 bottom-0 w-px bg-slate-200"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="relative">
          {/* Large decorative */}

          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-12 border-t border-b border-slate-100 py-16 px-8 -mx-4 sm:-mx-6 lg:-mx-8">
            <div className="max-w-2xl">
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-4xl md:text-6xl text-slate-900 mb-6 leading-[1.1] font-medium"
              >
                Expert medical guidance, <br />
                <span className="not-italic">instantly available.</span>
              </motion.h2>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
                className="text-xl text-slate-500 font-light max-w-md"
              >
                Help your community skip the wait. Bring reliable health answers to the people your organization serves.
              </motion.p>
            </div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <a
                href="mailto:founders@mycura.org?subject=Partnership%20Inquiry"
                className="group relative inline-flex items-center justify-center px-12 py-6 bg-[#003b82] text-white overflow-hidden transition-all hover:bg-[#002d62] rounded-full button-animate"
              >
                <span className="relative z-10 text-xl font-['Instrument_Serif'] italic mr-2">Partner With Cura</span>
                <ArrowRight className="relative z-10 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};